module.exports = __webpack_public_path__ + "img/aaa.d268957d.gif";